import { gql } from "@apollo/client"
import { Mutation, UpdateInvoicingEnabledContractSettingInput } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

const QUERY = gql`
  mutation InvoicingStaffUpdateInvoicingEnabled(
    $input: UpdateInvoicingEnabledContractSettingInput!
  ) {
    updateInvoicingEnabledContractSetting(input: $input) {
      contract {
        id
        contractorInvoicingSettings {
          id
          invoicingEnabled
        }
      }
      errors
    }
  }
`

export function useUpdateInvoicingEnabledContractSetting(
  options: InjectedOptions<
    Pick<Mutation, "updateInvoicingEnabledContractSetting">,
    { input: UpdateInvoicingEnabledContractSettingInput }
  >,
) {
  return useMutation(QUERY, options)
}
